import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CONSTANTS } from 'services/constants';
import moment from 'moment';
import BaseDatePicker from 'react-datepicker';
import ReactHtmlParser from 'components/UI/HtmlParser';
import { withFormHandler } from '../FormComponent';
import './styles.css';

function DatePicker({
    containerClassName,
    dateFormat,
    errorClassName,
    peekNextMonth,
    showMonthDropdown,
    showYearDropdown,
    error,
    onChange,
    path,
    placeholder,
    printErrors,
    style,
    value,
    maxDate,
    disabled,
    showTimeSelect,
    showTimeSelectOnly,
    timeIntervals,
})
{
    const handleChange = (inputValue) =>
    {
        if (onChange) onChange(inputValue ? moment(inputValue).format(dateFormat) : null, path);
    };

    const parsedError = Array.isArray(error) ? error[0] ?? '' : error;
    const errorContent = error && printErrors ? <span className={`${errorClassName} tw-flex tw-text-sm tw-text-red-600 dark:tw-text-[#FF565D]`}>{ReactHtmlParser(parsedError)}</span> : null;
    const borderClass = error && printErrors ? 'tw-border-red-600' : 'focus:tw-border-blue-400';

    const selectedDate = useMemo(() =>
    {
        if (value)
        {
            try
            {
                return moment(value, dateFormat).toDate();
            }
            catch (ignore)
            {
                console.warn(ignore); // eslint-disable-line no-console
            }
        }
        return null;
    }, [dateFormat, value]);

    return (
        <>
            <div className={`tw-w-full tw-relative tw-h-fit tw-py-1.5 tw-rounded tw-px-3 tw-border tw-bg-gray-50 dark:tw-bg-neutral-600 dark:tw-border-gray-400 hover:tw-border-primary-default ${containerClassName}`}>
                <BaseDatePicker
                    peekNextMonth={peekNextMonth}
                    showMonthDropdown={showMonthDropdown}
                    showYearDropdown={showYearDropdown}
                    maxDate={maxDate}
                    showTimeSelect={showTimeSelect}
                    showTimeSelectOnly={showTimeSelectOnly}
                    timeIntervals={timeIntervals}
                    placeholderText={placeholder}
                    onChange={handleChange}
                    dateFormat={dateFormat.replace(/D/gi, 'd').replace(/Y/gi, 'y').replace(/A/gi, 'a')}
                    style={{ ...style, ...{ transition: 'all 0.1s ease' } }}
                    className={`tw-h-8 tw-transition-all tw-w-full tw-outline-none tw-border-0 tw-bg-transparent ${borderClass}`}
                    selected={selectedDate}
                    dropdownMode="select"
                    popperProps={{
                        positionFixed: true,
                    }}
                    disabled={disabled}
                />
            </div>
            {errorContent}
        </>
    );
}

DatePicker.defaultProps = {
    dateFormat: CONSTANTS.FORMATS.DATE,
    peekNextMonth: true,
    showMonthDropdown: true,
    showYearDropdown: true,
    error: '',
    printErrors: true,
    showTimeSelect: false,
    showTimeSelectOnly: false,
    timeIntervals: 15,
};

DatePicker.propTypes = {
    containerClassName: PropTypes.string,
    dateFormat: PropTypes.oneOf(Object.values(CONSTANTS.FORMATS)),
    errorClassName: PropTypes.string,
    peekNextMonth: PropTypes.bool,
    showMonthDropdown: PropTypes.bool,
    showYearDropdown: PropTypes.bool,
    error: PropTypes.node,
    onChange: PropTypes.func,
    path: PropTypes.string,
    placeholder: PropTypes.string,
    printErrors: PropTypes.bool,
    style: PropTypes.object,
    value: PropTypes.string,
    maxDate: PropTypes.any,
    disabled: PropTypes.bool,
    showTimeSelect: PropTypes.bool,
    showTimeSelectOnly: PropTypes.bool,
    timeIntervals: PropTypes.number,
};

export default withFormHandler(DatePicker);
